

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface InstitutionsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Institutions {
    id?: any;
    name: string;
    cityName:string;
    countryId:any;
    stateId:any;
    
  parameters?: InstitutionsParameter[];
  links?: any;
}

export abstract class InstitutionsData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Institutions[]>;
  abstract create(url: string,data: Institutions): Observable<any>;
  abstract update(url: string,data: Institutions): Observable<any>;
  abstract delete(url: string): Observable<any>;
}